import React, { Component } from 'react';
import LevelTwoOne from './LevelTwoOne';
import LevelTwoTwo from './LevelTwoTwo';

class LevelTwo extends Component {
    render() {
        return (
            <div className="row lev-two">
                <div className="col-12 col-md-8">
                    <LevelTwoOne tagName="services"/>
                </div>
                <div className="col-12 col-md-4">
                    <LevelTwoTwo tagName="services" ServiceName="Treasury" ButtonText="Learn more" BgColor="dark-blue-bg"
                        ServiceDesc="We are a leading organization in the sale of Local and Foreign Currencies related products to non-bank clients for the purpose of investment and risk management." />
                </div>
            </div>
        );
    }
}

export default LevelTwo;